import { BasicService } from "./core/basic.service";

export class LogService extends BasicService {

  static getLog() {
    return this.http.post('/admin/log');
  }
}